<script setup>
// Audio Tools 分类枢纽 /free-tools/audio/（nuxt#19 P2）。
import "@/assets/styles/free-tools.css";
definePageMeta({ layout: "free-tools" });
const GROUP = ["audio"];
useHead({
  title: "Free Audio Tools — Convert, Compress, Trim Audio | SharkFoto",
  meta: [{ name: "description", content: "Free audio tools: convert, compress, trim, fade, merge, change speed, make ringtones and record voice — processed securely and never stored. No sign-up, no watermark." }],
  link: [{ rel: "canonical", href: "https://sharkfoto.com/free-tools/audio/" }],
  script: [{ type: "application/ld+json", innerHTML: JSON.stringify({ "@context": "https://schema.org", "@type": "CollectionPage", name: "Free Audio Tools", url: "https://sharkfoto.com/free-tools/audio/" }) }],
});
</script>

<template>
  <FreeToolsHub :group="GROUP" :crumb="[['Home', 'https://sharkfoto.com/'], ['Free Tools', 'https://sharkfoto.com/free-tools/'], ['Audio', '']]" title-prefix="Free audio tools" intro="Convert, compress, trim, fade, merge and speed-adjust audio, make ringtones and record voice — light edits in your browser, heavy transcodes on our servers." />
</template>
